export default "__VITE_ASSET__5xdXV_Qs__"